<template>
    <div class="permissions-created-groups">
        <div class="row">
            <div class="col-sm-12 p-lr-0-sm">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0 mb-3">
                                    <div class="dis-flex flex-m">
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="uim-svg fs-12">
                                                <svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="1em">
                                                    <path class="uim-tertiary" d="M22.8,11.9l-2.4-3.2c-0.6-0.8-1.5-1.2-2.4-1.2h-2v10c0,0.6-0.4,1-1,1h7c0,0,0,0,0,0c0.6,0,1-0.4,1-1v-5C23,12.3,22.9,12.1,22.8,11.9z"></path>
                                                    <path class="uim-tertiary" d="M15,18.5H2c-0.6,0-1-0.4-1-1c0,0,0,0,0,0v-12c0-1.7,1.3-3,3-3h9c1.7,0,3,1.3,3,3v12C16,18.1,15.6,18.5,15,18.5C15,18.5,15,18.5,15,18.5z"></path>
                                                    <path class="uim-primary" d="M16 12.5h7c0-.2-.1-.4-.2-.6l-2.4-3.2c-.6-.8-1.5-1.2-2.4-1.2h-2V12.5zM6 21.5c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3C9 20.2 7.7 21.5 6 21.5zM18 21.5c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3C21 20.2 19.7 21.5 18 21.5z"></path>
                                                </svg>
                                            </div>
                                        </div>
                                        <label class="label_name m-0">DPD Delivery</label>
                                    </div>
                                    <div class="btn small-form-btn bar-code pointer mt-0"><i class="uis uis-search fs-12"></i></div>
                                </div>
                                <div class="col-sm-12 p-0">
                                    <div class="form-control bor-dash text-center">
                                        <div class="brand_logo">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKGJ84tsMmdZ8BD0k038v6okqYJAisPVjrBg&amp;s" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 col-xl-4 col-xxl-3 col-sm-12 col-12 mb-4 p-lr-0-sm">
                        <div class="card">
                            <div class="card-body p-3">
                                <div class="col-sm-12 dis-flex flex-sb p-0 mb-3">
                                    <div class="dis-flex flex-m">
                                        <div class="sidebar-cat-icon dis-flex flex-m flex-c">
                                            <div class="uim-svg fs-12">
                                                <svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="1em">
                                                    <path class="uim-tertiary" d="M22.8,11.9l-2.4-3.2c-0.6-0.8-1.5-1.2-2.4-1.2h-2v10c0,0.6-0.4,1-1,1h7c0,0,0,0,0,0c0.6,0,1-0.4,1-1v-5C23,12.3,22.9,12.1,22.8,11.9z"></path>
                                                    <path class="uim-tertiary" d="M15,18.5H2c-0.6,0-1-0.4-1-1c0,0,0,0,0,0v-12c0-1.7,1.3-3,3-3h9c1.7,0,3,1.3,3,3v12C16,18.1,15.6,18.5,15,18.5C15,18.5,15,18.5,15,18.5z"></path>
                                                    <path class="uim-primary" d="M16 12.5h7c0-.2-.1-.4-.2-.6l-2.4-3.2c-.6-.8-1.5-1.2-2.4-1.2h-2V12.5zM6 21.5c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3C9 20.2 7.7 21.5 6 21.5zM18 21.5c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3C21 20.2 19.7 21.5 18 21.5z"></path>
                                                </svg>
                                            </div>
                                        </div>
                                        <label class="label_name m-0">Omniva Delivery</label>
                                    </div>
                                    <div class="btn small-form-btn bar-code pointer mt-0"><i class="uis uis-search fs-12"></i></div>
                                </div>
                                <div class="col-sm-12 p-0">
                                    <div class="form-control bor-dash text-center">
                                        <div class="brand_logo">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMVAB5ykc-FDWJP5icDK_F4TSxAH7VD0nM3A&amp;s" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.permissions-created-groups {
    padding-top: 2rem;

    .label_name {
        text-transform: uppercase;
        font-weight: 700;
    }

    .small-form-btn {
        display: flex!important;
        align-items: center!important;
        justify-content: center!important;
        max-height: 20px;
        padding: .2rem .65rem;
    }

    .form-control {
        max-height: 3rem;
        height: 100%;
        padding: .25rem;

        .brand_logo {
            width: 100%;
            height: 100%;
            
            img {
                height: 100%;
            }
        }
    }
}
</style>